// extracted by mini-css-extract-plugin
export default {"form":"LogInModal_form__xW2zq","text":"LogInModal_text__jyBCk"};